<template>
    <div class='auditError-container'>
    审核出错啦，请联系管理员
    </div>
</template>
<script>
export default {
    name:'auditError'
}
</script>
<style>
.auditError-container{
    height:100%;
    width:100%;
    display:flex;
    align-items:center;
    justify-content:center;
    background:#fff;
    font-size:6vw;
}
</style>